import memoize from 'transmute/memoize';
// @ts-expect-error untyped module sanitize
import Sanitize from 'sanitize';
import { Map as ImmutableMap } from 'immutable';
let sanitizers = ImmutableMap();
const sanitizeDocument = document.implementation.createHTMLDocument('');
try {
  sanitizeDocument.domain = window.location.hostname.indexOf('qa') >= 0 ? 'hubspotqa.com' : 'hubspot.com';
} catch (error) {
  // IE11 needs to have this but it throws an error in Chrome.
}
const {
  body: element
} = sanitizeDocument;
const BLOCKLISTED_STYLES = ['background-image', 'bottom', 'clear', 'float', 'left', 'opacity', 'position', 'right', 'top', 'visibility', 'white-space', 'z-index'];

// copied from https://github.com/gbirke/Sanitize.js/blob/6f83ed779f5bc4e1197f45cacbf20593b1c3bee1/lib/sanitize/config/relaxed.js
// with some modifications
// re-package does not include preset configs
const SANITIZE_CONFIG = {
  elements: ['a', 'b', 'blockquote', 'br', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'dd', 'div', 'dl', 'dt', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'i', 'img', 'li', 'ol', 'p', 'pre', 'q', 'small', 'span', 'strike', 'strong', 'sub', 'sup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'u', 'ul'],
  attributes: {
    a: ['href', 'rel', 'title'],
    blockquote: ['cite'],
    col: ['span', 'width'],
    colgroup: ['span', 'width'],
    div: ['data-hs-responsive-table', 'style'],
    img: ['align', 'alt', 'height', 'src', 'style', 'title', 'width'],
    li: ['style'],
    ol: ['start', 'style', 'type'],
    p: ['style'],
    q: ['cite'],
    span: ['style'],
    table: ['style', 'summary', 'width'],
    td: ['abbr', 'axis', 'colspan', 'rowspan', 'style', 'width'],
    th: ['abbr', 'axis', 'colspan', 'rowspan', 'scope', 'width'],
    tr: ['style'],
    ul: ['style', 'type']
  },
  protocols: {
    a: {
      href: ['http', 'https', 'mailto', Sanitize.RELATIVE]
    },
    blockquote: {
      cite: ['https', Sanitize.RELATIVE]
    },
    img: {
      src: ['https', Sanitize.RELATIVE]
    },
    q: {
      cite: ['https', Sanitize.RELATIVE]
    }
  }
};
const removeStyles = ({
  node
}) => {
  // (JC) DO NOT USE TRANSMUTE HERE!!
  if (node && node.style && node.style.removeProperty) {
    BLOCKLISTED_STYLES.forEach(style => node.style.removeProperty(style));
  }
  return null;
};
export const clean = memoize((text, config = SANITIZE_CONFIG, transformers = [removeStyles], removeNewLines = true) => {
  const div = sanitizeDocument.createElement('div');
  if (text && text !== '') {
    const sanitizeConfig = Object.assign({}, config, {
      transformers
    });
    const key = JSON.stringify(sanitizeConfig);
    element.innerHTML = text;
    if (!sanitizers.has(key)) {
      sanitizers = sanitizers.set(key, new Sanitize(sanitizeConfig));
    }
    try {
      const sanitizer = sanitizers.get(key);
      const fragment = sanitizer.clean_node(element);
      div.appendChild(fragment.cloneNode(true));
    } catch (err) {
      // Do nothing
    }
  }
  if (removeNewLines) {
    return div.innerHTML.replace('\n', '');
  }
  return div.innerHTML;
});